<template>
  <base-card :projectID="projectID" :categoryID="categoryID" :storyType="storyType" :isMarginless="isMarginless" :isRowLoading="isRowLoading" :isPinnableRow="isPinnableRow" :pinnedProjects="pinnedProjects" :disableLink="disableLink">
    <information :isRowLoading="isRowLoading" :isBlank="isBlank">
      <resource-type :project="project"></resource-type>
    </information>
    <project-title :isRowLoading="isRowLoading" :isBlank="isBlank" :title="title" :elementID="elementID" :customLineClamp="6"/>
    <!-- <span class="lower-container">
      <user :members="[project.user]"/>
    </span> -->
  </base-card>
</template>

<script>
import BaseCard from './BaseCard'
import base from '../mixins/base'
import visibility from '@/mixins/visibility'
import ProjectTitle from '../UI/Title'
import Information from '../UI/Information'
import ResourceType from '../UI/ResourceType'
import User from '../UI/User'
import cardSelector from '../mixins/cardSelector'
export default {
  name: 'WhitePaper',
  components: {
    BaseCard,
    ProjectTitle,
    Information,
    User,
    ResourceType
  },
  props: {
    projectID: Number,
    categoryID: Number,
    storyType: Boolean,
    isMarginless: [Boolean, String],
    isRowLoading: Boolean,
    isPinnableRow: Boolean,
    pinnedProjects: Array,
    disableLink: Boolean
  },
  mixins: [base, visibility, cardSelector]
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  ::v-deep .main-container {
    display: flex;
    align-items: center;
    max-height: 195px !important;
    @include touch {
      max-height: 150px;
    }
    @include mobile {
      max-height: 140px;
    }
    .story-title {
      height: fit-content;
    }
    height: 100%;
  }
</style>
